import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Tab } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/community.js';
import FaqEvent from '../../components/FaqEvent';
import axios from 'axios';

function CommunityPortal() {

    const [communityWebPortalInfo, setCommunityWebPortalInfo] = useState([]);

    useEffect(() => {
        const getPortalInfo = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/community-portal/find-all`).then(res => {
                setCommunityWebPortalInfo(res.data)
            }).catch(err => console.error(err))
        }
        getPortalInfo();
    },[])

    // useEffect(() => {
    //     const accordionButton = document.querySelectorAll(".accordion-button");
    //     console.log(accordionButton)
    //     accordionButton.forEach(button => {
    //         button.addEventListener("click", () => {
                
    //             button.classList.toggle("active");
    //             const content = button.nextElementSibling;

    //             if (!button.classList.contains("active")) {
    //                 content.className = "accordion-content show";
    //                 content.style.maxHeight = content.scrollHeight + "px";
    //             } else {
    //                 content.className = "accordion-content";
    //                 content.style.maxHeight = "0";
    //             }
    //         });
    //     });
    // },[]);

    useEffect(() => {
        document.title = 'Community Portal | REAL FM';
        const courseButton = document.querySelectorAll(".course-button");
        courseButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "course-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "course-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    });

    return (
        <div className="main-wrapper course-details-page" >

            {/* Header 2 */}
            <HeaderTwo />

            {/* Breadcroumb */}
            <BreadcrumbBox title="Community Web Portal" />

            <Styles>
                {/* Course Details */}
                <section className="course-details-area">
                    <Container className="card custom-card">
                    
                        <Row>
                                <Col lg="12" md="12" sm="12">
                                    <div className="course-details-top">
                                    
                                        <div className="course-tab-list">
                                            <Tab.Container defaultActiveKey="overview">
                                            {
                                                communityWebPortalInfo && communityWebPortalInfo.length > 0 ? communityWebPortalInfo.map((info, i) => (
                                                <Tab.Content key={i}>
                                                    <Tab.Pane eventKey="overview" className="overview-tab">
                                                  
                                                                <>
                                                                <div className="course-desc">
                                                                    <h4>{info.communityTagLine}</h4>
                                                                </div>
                                                                <div className="course-feature ">
                                                                    <Row>
                                                                    
                                                                        <Col sm="12">
                                                                           
                                                                            <p dangerouslySetInnerHTML={{ __html: info.communityDesc}}>

                                                                            </p> 

                                                                        </Col>                                                        
                                                                    </Row>
                                                                    
                                                                </div>
                                                                </>
                                                       
                                                        
                                                    </Tab.Pane>
                                                    
                                                </Tab.Content>
                                                )): "No content available"
                                                    }
                                                        
                                            </Tab.Container>
                                        </div>
                                    </div>
                                </Col>
                                
                        </Row>
                    <FaqEvent />
                </Container>
            </section>
        </Styles>

            {/* Footer 2 */}
            <FooterTwo />

        </div>
    )
}

export default CommunityPortal